import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=838fa2bc&scoped=true"
import script from "./Matches.vue?vue&type=script&lang=js"
export * from "./Matches.vue?vue&type=script&lang=js"
import style0 from "./Matches.vue?vue&type=style&index=0&id=838fa2bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838fa2bc",
  null
  
)

export default component.exports